import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formData'
})
export class FormDataPipe implements PipeTransform {
  transform(value: string | Array<string>, ..._args: Array<unknown>): string {
    return Array.isArray(value) ? value.join('') : value;
  }
}
